<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [legend]="chartOptions.legend!"
        [chart]="chartOptions.chart!"
        [tooltip]="chartOptions.tooltip!"
        [dataLabels]="chartOptions.dataLabels!"
        [stroke]="chartOptions.stroke!"
        [colors]="chartOptions.colors!"
        [labels]="chartOptions.labels!"
        [responsive]="chartOptions.responsive!"
    ></apx-chart>
</div>